import type { TargetMetricConfig, TargetStoragePeriod } from "@/grid/core/target-policy";
import type { TargetMetricConfigRow } from "@/grid/core/types";
import { supabase } from "@/lib/supabase";

export function mapTargetMetricConfigRow(row: TargetMetricConfigRow): TargetMetricConfig {
  return {
    department: row.department,
    metric: row.metric,
    setAt: row.set_at as TargetStoragePeriod,
    inferMtdFromWeekly: row.infer_mtd_from_weekly,
    inferQtdFromWeekly: row.infer_qtd_from_weekly,
    inferQtdFromMonthly: row.infer_qtd_from_monthly,
  };
}

export async function fetchTargetMetricConfigs(
  departmentId: string,
): Promise<TargetMetricConfig[]> {
  const { data, error } = await supabase
    .from("target_metric_config")
    .select(
      "department, metric, set_at, infer_mtd_from_weekly, infer_qtd_from_weekly, infer_qtd_from_monthly",
    )
    .eq("department", departmentId);

  if (error) throw error;

  return (data ?? [])
    .filter(
      (row): row is TargetMetricConfigRow =>
        row.department != null &&
        row.metric != null &&
        row.set_at != null &&
        row.infer_mtd_from_weekly != null &&
        row.infer_qtd_from_weekly != null &&
        row.infer_qtd_from_monthly != null,
    )
    .map(mapTargetMetricConfigRow);
}

export async function upsertTargetMetricConfig(config: TargetMetricConfig): Promise<void> {
  const { error } = await supabase.rpc("wh_upsert_target_metric_config", {
    p_department: config.department,
    p_metric: config.metric,
    p_set_at: config.setAt,
    p_infer_mtd_from_weekly: config.inferMtdFromWeekly,
    p_infer_qtd_from_weekly: config.inferQtdFromWeekly,
    p_infer_qtd_from_monthly: config.inferQtdFromMonthly,
  });

  if (error) throw error;
}
